// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"c7a508d6","196":"d361cf34","331":"9217be1f","351":"d397b0b6","427":"e25324c8","533":"b52b3c9d","841":"17b33521","848":"18b2ac69","972":"12dda88e"}[chunkId] + ".chunk.css";
};